firebird.factory('videoMediaPathService', [
    '$window',
    '$timeout',
    'configService',
    'videoGlobalService',
    'logService',
    function ($window, $timeout, configService, videoGlobalService, logService) {
        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // mediapath is used to change the audio/video path to be sfu-fs (default if null), sfu (experimental) or direct (not yet available)
            self.mediapath = null;

            self.initMediaPath = initMediaPath;
            self.onMediaPathVideoEnabled = onMediaPathVideoEnabled;
            self.reattachStreamWithVideoTrack = reattachStreamWithVideoTrack;
            self.attachAudioOnlyMediaStream = attachAudioOnlyMediaStream;
            self.playVideoElement = playVideoElement;
            self.createAudioStream = createAudioStream;
        }

        function initMediaPath() {
            // mediapath - do not use URL parameter here
            self.mediapath = configService.getServerValue('mediapath');
        }

        function onMediaPathVideoEnabled(div, enabled, is_screen, operationType, doAttachMediaStream, stream) {
            var userId = div.getAttribute('user');
            logService.log(
                'videoroomCtrl - onMediaPathVideoEnabled: userId=' +
                    userId +
                    ' enabled=' +
                    enabled +
                    ' is_screen=' +
                    is_screen +
                    ' operation=' +
                    operationType +
                    ' attach=' +
                    doAttachMediaStream +
                    ' stream=' +
                    !!stream
            );

            if (div.audioPlayTimer) {
                // if it was created in attachAudioOnlyMediaStream
                logService.log('videoroomCtrl - onMediaPathVideoEnabled: cancel video element play timeout');
                $timeout.cancel(div.audioPlayTimer);
                delete div.audioPlayTimer;
            }

            if (enabled) {
                if (!is_screen) {
                    $window.$(div).removeClass('audioonly');
                }
                // this is not done in appendVideoLayout for sfu case, so do this here.
                self.addLayoutVideoItem(userId, div);
            } else {
                if (!is_screen) {
                    $window.$(div).addClass('audioonly');
                }

                self.removeLayoutVideoItem(userId, div);

                if (div == self.maxvideo) {
                    // TODO: if removed element was spotlight, pick another if available. else set to null.
                    var nextVideoElement = null;
                    if (self.preferredLayout === 'spotlight') {
                        nextVideoElement =
                            $window.$('#videoroom-videos > div.remote.screen').get(0) ||
                            $window.$('#videoroom-videos > div.remote[user]:not(.audioonly)').get(0) ||
                            null;
                    }
                    self.setSpotlightVideo(nextVideoElement);
                }
            }

            // attach stream
            if (is_screen) {
                logService.log('videoroomCtrl - onMediaPathVideoEnabled: attachMediaStream for screen, id=' + userId);
                $window.Janus.attachMediaStream(
                    $window.$('#videoroom-videos > div[user="' + userId + '"] video').get(0),
                    stream
                );
            } else if (doAttachMediaStream) {
                if (operationType === 'create') {
                    if (stream) {
                        var remoteVideoPaused =
                            $window.$(div).hasClass('remote') && div.getAttribute('enable') != 'true';
                        if ($window.$(div).hasClass('audioonly') || remoteVideoPaused) {
                            self.attachAudioOnlyMediaStream(userId, div, stream);
                        } else {
                            logService.log('videoroomCtrl - onMediaPathVideoEnabled: attachMediaStream, id=' + userId);
                            $window.Janus.attachMediaStream($window.$(div).find('video')[0], stream);
                        }
                    } else {
                        logService.log('videoroomCtrl - onMediaPathVideoEnabled: invalid stream');
                    }
                } else if (operationType === 'enable') {
                    if (!$window.$(div).hasClass('audioonly') && div.savedSrcObject) {
                        // when sender turns on webcam we need to reattach correct stream with video track
                        self.reattachStreamWithVideoTrack(userId, div);
                    } else {
                        // The user does not interact with the UI for a long time (e2ee key is not entered yet),
                        // but sender has already turned on and turned off webcam.
                        // Or attendee has muted webcam immediately after unmute (after entered e2ee key).
                        // => <video> element is in 'paused' state, do the same workaround with attachAudioOnlyMediaStream as for createVideoElement
                        var videoElement = $window.$(div).find('video')[0];
                        if (videoElement) {
                            if (videoElement.paused) {
                                logService.log(
                                    'videoroomCtrl - onMediaPathVideoEnabled: video element is in paused state'
                                );
                                if (videoElement.srcObject) {
                                    self.attachAudioOnlyMediaStream(userId, div, videoElement.srcObject);
                                } else {
                                    logService.log(
                                        'videoroomCtrl - onMediaPathVideoEnabled: invalid video element source object'
                                    );
                                }
                            }
                        } else {
                            logService.log('videoroomCtrl - onMediaPathVideoEnabled: invalid video element');
                        }
                    }
                }
            }
        }

        function attachAudioOnlyMediaStream(id, div, stream) {
            logService.log(
                'videoroomCtrl - attachAudioOnlyMediaStream: create separate stream with audio track, id=' + id
            );

            // Workaround for ANYAM-81688 New joined attendee don't hear others who turned off camera during E2EE meeting
            // and for ANYAM-83295 Audio from attendee is lost if he has muted webcam immediately after unmute in E2EE meeting
            // Dynamically added <video> element can't play audio if there is also muted video track in the stream.
            // Create separate stream with only audio track and set it to srcObject of <video> element.
            // Note: save old stream to div, we'll reattach it when execute enableVideoElement.

            var videoElement = $window.$(div).find('video')[0];

            if (stream.getAudioTracks().length > 0) {
                var audioStream = self.createAudioStream(stream.getAudioTracks()[0]);

                if (div.savedSrcObject) {
                    logService.log(
                        'videoroomCtrl - attachAudioOnlyMediaStream: overwriting savedSrcObject, audio tracks ' +
                            div.savedSrcObject.getAudioTracks().length +
                            '=>' +
                            stream.getAudioTracks().length +
                            ' video tracks ' +
                            div.savedSrcObject.getVideoTracks().length +
                            '=>' +
                            stream.getVideoTracks().length
                    );
                }
                div.savedSrcObject = stream;
                $window.Janus.attachMediaStream(videoElement, audioStream);

                // If a <video> element is added to the DOM before the user starts interacting with the document,
                // the <video> element will be in a 'paused' state. So we need next code to play it explicitly.
                // If we execute the following code without a timeout, we get an error:
                // NotAllowedError: play() failed because the user didn't interact with the document first. https://goo.gl/xX8pDD
                div.audioPlayTimer = $timeout(function () {
                    self.playVideoElement(id, videoElement);
                }, 2000);
            } else {
                logService.log('videoroomCtrl - attachAudioOnlyMediaStream: missing audio track, attach without');
                $window.Janus.attachMediaStream(videoElement, stream);
            }
        }

        function createAudioStream(audioTrack) {
            var audioStream = new MediaStream();
            audioStream.addTrack(audioTrack);

            return audioStream;
        }

        function playVideoElement(id, videoElement) {
            if (!videoElement.paused) {
                return;
            }

            logService.log(
                'videoroomCtrl - attachAudioOnlyMediaStream: video element is in "paused" state, trying to play it, id=' +
                    id
            );

            videoElement
                .play()
                .then(function () {
                    logService.log('videoroomCtrl - attachAudioOnlyMediaStream: video element is playing, id=' + id);
                })
                .catch(function (error) {
                    logService.log(
                        'videoroomCtrl - attachAudioOnlyMediaStream: unable to play the video element, id=' +
                            id +
                            ': ' +
                            error
                    );
                });
        }

        function reattachStreamWithVideoTrack(userId, div) {
            logService.log('videoroomCtrl - reattachStreamWithVideoTrack: id=' + userId);

            var videoElement = $window.$(div).find('video')[0];
            videoElement.srcObject = div.savedSrcObject;
            delete div.savedSrcObject;
        }
    }
]);
